import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertBell18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.99976 0.25C5.82412 0.25 3.24976 2.82436 3.24976 6V8.66667C3.24976 9.99614 2.35051 10.949 1.59976 11.95C0.734512 13.1037 1.55768 14.75 2.99976 14.75H6.25C6.25 16.3327 7.3084 17.75 9 17.75C10.6916 17.75 11.75 16.3327 11.75 14.75H14.9998C16.4418 14.75 17.265 13.1037 16.3998 11.95C15.649 10.949 14.7498 9.99614 14.7498 8.66667V6C14.7498 2.82436 12.1754 0.25 8.99976 0.25ZM10.25 14.75H7.75C7.75 15.5086 8.1316 16.25 9 16.25C9.8684 16.25 10.25 15.5086 10.25 14.75ZM4.74976 6C4.74976 3.65279 6.65255 1.75 8.99976 1.75C11.347 1.75 13.2498 3.65279 13.2498 6V8.66667C13.2498 10.3648 14.238 11.5677 15.1998 12.85C15.3234 13.0148 15.2058 13.25 14.9998 13.25H2.99976C2.79375 13.25 2.67615 13.0148 2.79976 12.85C3.76147 11.5677 4.74976 10.3648 4.74976 8.66667V6Z'
      fill='currentColor'
    />
  </Svg>
);

AlertBell18.displayName = 'AlertBell18';
export default AlertBell18;
